import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { logPageView, initGA } from 'utils/analytics';
import Footer from 'components/MiniFooter';
import queryString from 'query-string';
import { Button } from 'react-toolbox/lib/button';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Session from 'components/SessionReplica';
import UserNavbar from 'components/Navbar';
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component

import style from './AthleteById.scss';// to import local scss fle
import { selector } from './redux';
import { getRequestById, getSAProfile } from './actions';
import { updateConversation } from '../DashBoardCoach/actions';

class AthleteById extends Component {

  static propTypes = {
    profile: PropTypes.shape(),
    match: PropTypes.shape(),
    requested: PropTypes.bool,
    getProfileForCoach: PropTypes.func,
    updateConversation: PropTypes.func.isRequired,
    getSAProfile: PropTypes.func,
    getRequestById: PropTypes.func.isRequired,
    request: PropTypes.shape(),
    conversationUpdated: PropTypes.bool.isRequired,
    location: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    history: {},
    profile: Map(),
    request: Map(),
    getSAProfile: () => {},
    requested: false,
    getProfileForCoach: () => {},
    match: {
      params: {
        id: '',
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      showFullScreenVideo: false,
      videoOnProfile: false,
      showActionableItems: false,
      coachEmail: '',
    };
  }

  componentWillMount() {
    const query = queryString.parse(this.props.location.search);
    const coachEmail = query.coach_email;
    const saId = query.sa;
    const requestId = query.req;
    if (requestId && requestId.length > 0 && coachEmail && coachEmail.length > 0
        && saId && saId.length > 0) {
      this.props.getRequestById(requestId);
      this.props.getSAProfile(saId);
    }
  }

  componentDidMount() {
    initGA();
        logPageView(this.props.match.path); // eslint-disable-line
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.conversationUpdated !== this.props.conversationUpdated) {
      const id = this.props.match.params.id;
      this.props.getProfileForCoach(id);
    }
  }

  updateContactInfo = () => {
    const { request, profile } = this.props;
    const lastconvo = request.get('conversation').last();
    const conversation = {
      id: request.get('id'),
      action: 'SA SENT CONTACT INFO',
      created_by: 'SA',
      sa_email: profile.get('sa_email'),
      sa_mobile: profile.get('sa_mobile'),
      sa_name: profile.get('fullname'),
      coach_email: lastconvo.get('coach_email'),
    };
    this.props.updateConversation(conversation, 'public');
  };


  render() {
    const { request, requested } = this.props;

    let lastConvo = {};
    let lastConvoAction = '';
    if (request.size > 0) {
      const convo = this.props.request.get('conversation');
      lastConvo = convo.last();
      lastConvoAction = lastConvo.get('action');
    }
    const renderSuccessful = renderIf(lastConvoAction === 'SA SENT CONTACT INFO');
    const renderSendContactInfoButton = renderIf(lastConvoAction === 'SEND CONTACT INFO');
    const renderIfLoading = renderIf(requested && request.size > 0);
    return (
      <div className={style.container}>
        <div className={cn('row', style.headerContainer)}>
          <div className={cn('col s12', style.navBar)}>
            <UserNavbar {...this.props} usedFor="profile_page" />
          </div>
        </div>
        {renderIfLoading(
          <FullScreenLoader />,
          )}
        <div className={cn('row', style.infoContainer)}>
          <div className={cn('col s12', style.actionContainer)}>
            {renderSuccessful(
              <span className={style.greenMessage}>
                Your contact info has been sent successfully!
              </span>,

            )}
            {renderSendContactInfoButton(
              <div className={style.actionableButtonContainer}>
                <span>Click below button to send your contact info to coach.</span><br /> <br />
                <Button label="SEND CONTACT INFO" onClick={this.updateContactInfo} />
              </div>,
            )}
          </div>
        </div>
        <div className={cn('row', style.profileContainer)} >
          <Footer />
        </div>
      </div>
    );
  }
}


export default connect(selector,
  { getRequestById,
    getSAProfile,
    updateConversation,
  })(Session(AthleteById));



// WEBPACK FOOTER //
// ./src/containers/PublicAthletePage/AthleteById.js